import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Buscando from 'Component/Buscando';
import { IndisponibilidadeLista } from 'Component/Indisponibilidade';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarIndisponibilidadesQuery } from 'View/Service/Default/Indisponibilidades';

const Indisponibilidades = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    data: { indisponibilidades, paginacao } = {},
    isFetching,
    isLoading,
    refetch,
  } = useRecuperarIndisponibilidadesQuery({
    page: searchParams.get('pagina') || 1,
    options: { usuario_id: id },
    sort: 'criado',
    direction: 'desc',
  });

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-6 mb-3">
          <Botao icone="arrow-clockwise" onClick={refetch} className="me-2" />
          <BotaoLink
            tema="success"
            icone="plus-lg"
            to={`/usuarios/editar/${id}/indisponibilidades/adicionar`}
          >
            Adicionar
          </BotaoLink>
        </div>
      </div>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={indisponibilidades?.length}
        redirecionar={`/usuarios/editar/${id}/indisponibilidades/adicionar`}
      />
      <div className="bg-white shadow-sm rounded">
        {indisponibilidades?.map((folha) => (
          <IndisponibilidadeLista
            key={`${folha.id}-${folha.modificado}`}
            dados={folha}
          />
        ))}
      </div>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </React.Fragment>
  );
};

export default Indisponibilidades;
